/**
 * @file paddle hack time line
 * @author wanzhongyun
 */

import { RootObject, Content3 } from '../../type';

import './style.less';

const HackTimeLine = (props: RootObject['timeArrange']) => {
    const { titleImg, backImg, years, describe, markImg, content, subTitle } = props;
    const getSub = (content: Content3[]) => {
        const timeArray: { time: string; mark: number }[] = [];
        let resultIndex: number = 0;
        const getCurrentTime = () => {
            const date = new Date();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            return `${month > 9 ? month : `0${month}`}.${day > 9 ? day : `0${day}`}`;
        };
        content.forEach((value: Content3, index: number) => {
            timeArray.push({
                time: value.time,
                mark: index
            });
        });
        timeArray.length > 0 &&
            timeArray.forEach((value: { time: string; mark: number }, myIndex: number) => {
                if (value.time.indexOf('-') === -1) {
                    if (value.time === getCurrentTime()) {
                        resultIndex = myIndex;
                    }
                } else {
                    // eslint-disable-next-line
                    let resA: string[] = value.time.replace(/\-/g, ' ').split(' ');
                    resA.forEach((i: string) => {
                        if (i === getCurrentTime()) {
                            resultIndex = myIndex;
                        }
                    });
                }
            });
        return resultIndex;
    };

    return (
        <div className="paddle-hack-time-line-f-wrapper">
            <div className="paddle-hack-time-line-f-content">
                <img className="paddle-hack-time-line-f-title" src={titleImg} alt="" />
                <div className="paddle-hack-time-line-f-sub-title">{subTitle ?? ''}</div>

                <div className="paddle-hack-time-line-f-content-back">
                    <div className="paddle-hack-time-line-f-header" style={{ backgroundImage: `url(${backImg})` }}>
                        <span>{years ?? ''}</span>
                        <span>{describe ?? ''}</span>
                    </div>
                    <div className="paddle-hack-time-line-f-bottom">
                        {content?.map((value: Content3, index: number) => {
                            return (
                                <div className="bottom-li" key={index}>
                                    <div className="li-content">
                                        <div className="li-content-time">{value.time ?? ''}</div>
                                        <div className="li-content-mark">
                                            <div className="mark-wrapper">
                                                {getSub(content) === index ? (
                                                    <div
                                                        className="mark-back"
                                                        style={{ backgroundImage: `url(${markImg})` }}
                                                    ></div>
                                                ) : (
                                                    <div className="mark-round"></div>
                                                )}
                                            </div>
                                            <div className="li-line"></div>
                                        </div>
                                        <div className="li-content-desc">
                                            <span>{value.title ?? ''}</span>
                                            <span>{value.describe ?? ''}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HackTimeLine;
